/* Some suppliers read personalization only from the order note (Beleco Jewelry via
   Shopify Collective: "add your details in the Order Notes box"). This keeps a block in
   the cart note listing every personalized line, rebuilt whenever the cart changes;
   anything the customer writes outside the block is kept. */
(() => {
  const START = '— Personalization (please keep) —';
  const END = '— End of personalization —';
  // Set by the product page on lines whose supplier reads the order note.
  const FLAG = '_auriani_note';

  function block(cart) {
    const lines = cart.items
      .filter(item => item.properties?.[FLAG])
      .map(item => {
        const details = Object.entries(item.properties).filter(([k, v]) => v && !k.startsWith('_')).map(([k, v]) => `${k}: ${v}`).join(', ');
        return `${item.quantity} × ${item.product_title} (${item.variant_title}) — ${details}`;
      });
    return lines.length ? `${START}\n${lines.join('\n')}\n${END}` : '';
  }

  function merge(note, generated) {
    const literal = s => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const pattern = new RegExp(`${literal(START)}[\\s\\S]*?${literal(END)}`, 'g');
    const own = (note || '').replace(pattern, '').trim();
    return [generated, own].filter(Boolean).join('\n\n');
  }

  let running = Promise.resolve();
  function sync(cart) {
    running = running.then(async () => {
      const current = cart || await fetch('/cart.js', {headers: {Accept: 'application/json'}}).then(r => r.json());
      const note = merge(current.note, block(current));
      if (note === (current.note || '')) return;
      await fetch('/cart/update.js', {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({note})});
    }).catch(() => {});
    return running;
  }

  document.addEventListener('auriani:cart-changed', event => sync(event.detail?.cart));
  window.AurianiOrderNote = {sync, block, merge};
  sync();
})();
